import React, { useEffect } from 'react';
import classnames from 'classnames';
import CircularProgress from 'material-ui/CircularProgress';
import InfiniteScroll from 'react-infinite-scroller';
import { PRODUCTS_LIMIT } from 'swag-common/constants/goodie-giveaway';
import { EmptyList } from '../empty-list';
import { GoodieGiveawayProductCard } from '../goodie-giveaway-product-card';
import responsiveClasses from './goodie-giveaway-products.scss';
import fixedClasses from './goodie-giveaway-products-fixed.scss';
const loaderStyles = {
  top: '20px',
  margin: '0 auto',
  display: 'block'
};
export const GoodieGiveawayProductsComponent = ({
  products,
  categoryId,
  page,
  shouldLoadMore,
  isLoading,
  isFixed = false,
  selectedProducts = {},
  wrapperClassName,
  link,
  isViewOnly,
  onProductsLoad,
  onProductClick,
  onQuantityChange,
  giveawayColor
}) => {
  const classes = isFixed ? fixedClasses : responsiveClasses;
  useEffect(() => {
    onProductsLoad({
      categories: categoryId,
      page: 1,
      limit: PRODUCTS_LIMIT
    });
  }, [categoryId]);
  const handleLoadMoreProducts = () => {
    onProductsLoad({
      categories: categoryId,
      page: page + 1,
      limit: PRODUCTS_LIMIT
    });
  };
  const handleProductClick = product => {
    if (onProductClick && link) {
      onProductClick(product, link);
    }
  };
  const handleQuantityChange = (productId, quantity) => {
    if (onQuantityChange && link) {
      onQuantityChange(productId, quantity, link);
    }
  };
  if (!products) {
    return null;
  }
  return products.length === 0 ? /*#__PURE__*/React.createElement(EmptyList, {
    wrapperClassName: classes.emptyList,
    title: "No products match your selection"
  }) : /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.contentWrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement(InfiniteScroll, {
    loadMore: handleLoadMoreProducts,
    hasMore: shouldLoadMore,
    initialLoad: false
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.itemsContainer
  }, products.map(product => /*#__PURE__*/React.createElement(GoodieGiveawayProductCard, {
    color: giveawayColor,
    key: String(product._id),
    isFixed: isFixed,
    quantity: selectedProducts[String(product._id)] || 0,
    product: product,
    onClick: handleProductClick,
    onChange: handleQuantityChange,
    ableToSelect: !isViewOnly
  })))), isLoading && /*#__PURE__*/React.createElement(CircularProgress, {
    key: "infinite-products-progress",
    style: loaderStyles
  }));
};